/**
 * Marca GuardIA.
 *
 * El logotipo se referencia desde `guardiasync.com`, que es donde vive el
 * archivo oficial —el del automóvil, la palabra GuardIA y la mascota—. No hay
 * ninguna copia dentro de este repositorio: el proyecto no tenía carpeta de
 * recursos y traer una imagen aparte crea una segunda versión que se queda
 * vieja el día que la marca cambie. Si algún día se quiere servir desde el
 * mismo dominio, se copia el archivo y se cambia esta constante, que es el
 * único lugar donde aparece.
 *
 * `alt` describe la marca, no el archivo: quien usa lector de pantalla necesita
 * saber que eso es GuardIA, no que es un PNG.
 */

export const GUARDIA_LOGO_URL = "https://guardiasync.com/GuardIA_header_logo_oficial.png";

/**
 * El logotipo, con su proporción intacta.
 *
 * La altura manda y el ancho se calcula solo (`w-auto`): fijar los dos deforma
 * el automóvil y la mascota, que es justo lo que no puede pasarle a un logo.
 */
export function GuardiaLogo({ className = "h-9" }: { className?: string }) {
  return (
    <img
      src={GUARDIA_LOGO_URL}
      alt="GuardIA"
      className={`${className} w-auto max-w-full object-contain`}
      /* Es lo primero que se ve: no se difiere. */
      loading="eager"
      decoding="async"
    />
  );
}

/** Marca completa del producto: logotipo más el nombre de esta aplicación. */
export function BrandLockup({ compact = false }: { compact?: boolean }) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <GuardiaLogo className={compact ? "h-8" : "h-9"} />
      <span
        className="hidden truncate border-l border-white/20 pl-3 font-display text-[15px] font-semibold text-white sm:inline"
        /* Separado del logotipo por una línea, no pegado: son dos cosas —la
           marca y el producto— y leerlas juntas confunde cuál es cuál. */
      >
        Driving
      </span>
    </div>
  );
}
